import { Injectable } from '@angular/core';
import { PaymentAPI } from '../../shared/api.url';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '../../shared/models/api.response';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'   // or leave out this line if you're adding it in module providers
})

export class PaymentService {
    currentPlanAmount: number = 0;
    currentPlanName: string = '';
    billingCycle : boolean;
    billingType : string;
    apiUrl = environment.apiBaseUrl;

    constructor(public http: HttpClient) { }

    getOtpForPayment(model: any) {
        return this.http.post<ApiResponse>(this.apiUrl + PaymentAPI.getOtpForPayment, model);
    }

      GetUserSubscriptionDetailsWithPages(uid: string) {
        
        const params = new HttpParams().set('userId', uid);
        return this.http.get<ApiResponse>(this.apiUrl + PaymentAPI.GetUserSubscriptionDetailsWithPages, { params });
    }
    
CancleSubsciption(requestData: { subscriptionId: string, reason: string }) {
  return this.http.post<ApiResponse>(this.apiUrl + PaymentAPI.CancleSubsciption, requestData);
}

 GetUserSubscriptionDetailsWithPagesProfile(uid: string, companyId: number) {
    const params = new HttpParams()
        .set('userId', uid)
        .set('companyId', companyId);
 
    return this.http.get<ApiResponse>(
        this.apiUrl + PaymentAPI.GetUserSubscriptionDetailsWithPagesProfile,
        { params }
    );
  }

      GetUserSubscriptionDetailsWithPagesforPlan(uid: string) {
        
        const params = new HttpParams().set('userId', uid);
        return this.http.get<ApiResponse>(this.apiUrl + PaymentAPI.GetUserSubscriptionDetailsWithPagesPlan, { params });
    }


    verifyOtpForPayment(model: any) {
        return this.http.post<ApiResponse>(this.apiUrl + PaymentAPI.verifyOtpForPayment, model);
    }

    processCardPayment(model: any){
        
        return this.http.post<ApiResponse>(this.apiUrl + PaymentAPI.processPayment, model);
    }

    getAllActivePlans() {
        return this.http.get<ApiResponse>(this.apiUrl + PaymentAPI.getAllActivePlans);
    }

    getAllCoupons() {
        return this.http.get<ApiResponse>(this.apiUrl + PaymentAPI.getAllCoupons);
    }

    getCouponByName(couponName: string) {
        const params = new HttpParams().set('couponName', couponName);
        return this.http.get<ApiResponse>(this.apiUrl + PaymentAPI.getCouponByName, { params });
    }

    initializePayPalExpress(paymentData: any): Observable<any> {
      return this.http.post('/api/payments/paypal/initialize', paymentData);
    }

    completePayPalExpress(model: any): Observable<any> {
      return this.http.post('/api/payments/paypal/complete', model);
    }

    getHostedFormToken(tokenRequest: any): Observable<any> {
      return this.http.post('/api/payments/hosted-form-token', tokenRequest);
    }

    processPayment(model: any){
      return this.http.post<ApiResponse>(this.apiUrl+ PaymentAPI.processPayment, model);
    }

    processPayPalExpressCheckout(paymentData: any): Observable<any> {
        return this.http.post<ApiResponse>(this.apiUrl+ PaymentAPI.processPayment, paymentData);
    }

    processPayPalPayment(model: any){
      return this.http.post<ApiResponse>(this.apiUrl+ PaymentAPI.processPaypalPayment, model);
    }

    processPayPalSubscription(model: any) {
      return this.http.post<any>(this.apiUrl+ PaymentAPI.confirm, model);
    }

    getUserSubscriptionDetailsWithPages(){
        return this.http.get<ApiResponse>(this.apiUrl + PaymentAPI.getUserSubscriptionDetailsWithPages);
    }


}